
// stringify class or instance of a class
// eslint-disable-next-line @typescript-eslint/ban-types
export function stringifyClass(token: object | Function | undefined): string {
  if (typeof token === 'object') {
    return token.constructor.name;
  }
  if (token == null) {
    return '' + token;
  }
  return token.name;
}
